import { http } from "./http";

export const usersApi = {
  list: (params) => http.get("/users", { params }).then((r) => r.data),

  // não vamos usar agora, mas já deixa pronto
  getById: (id) => http.get(`/users/${id}`).then((r) => r.data),
};
